import request from "@/utils/request";

//获取系统日志
export function getSystemLogs(data){
    return request({
        url:'/admin/getSystemLogs',
        data:data,
        method:'get'
    })
}
